import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import tokens from '@verifime/design-tokens';
import { validationRules } from '@verifime/utils';
import { useState } from 'react';
import * as yup from 'yup';
import { ColoredIcon } from '../ColoredIconAndChip';
import {
  GenerateFormFields_New,
  getFieldsRules_New,
  RenderType,
  TFormFieldsAndRules_New,
} from '../Form';
import { useCustomForm } from '../Form/useCustomForm';

const formFieldsAndRules: TFormFieldsAndRules_New = {
  row1: [
    {
      fieldName: 'type',
      label: 'Type',
      renderType: RenderType.Select,
      items: [{ code: 'EMAIL', label: 'Email' }],
      rules: yup.string().required('Type is required'),
    },
  ],
  row2: [
    {
      fieldName: 'detail',
      label: 'Email',
      renderType: RenderType.Text,
      rules: validationRules.REQUIRED_EMAIL_RULES,
    },
  ],
};

export interface TAddOrganisationNotificationFromData {
  type: string;
  detail: string;
}

interface AddOrganisationNotificationProps {
  onAddNotification: (fromData: TAddOrganisationNotificationFromData) => Promise<void>;
}

export default function AddOrganisationNotification({
  onAddNotification,
}: Readonly<AddOrganisationNotificationProps>) {
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useCustomForm({
    schema: getFieldsRules_New(formFieldsAndRules),
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    reset();
  };

  const onFormSubmit = async (formData: any) => {
    setIsSubmitting(true);
    try {
      await onAddNotification(formData);
      handleClose();
    } catch (error) {
      console.error('Error submitting notification:', error);
    }

    setIsSubmitting(false);
  };

  return (
    <>
      <Button variant="text" startIcon={<ColoredIcon iconName="addRounded" />} onClick={handleOpen}>
        Add New
      </Button>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Add Organisation Notification</DialogTitle>

        <DialogContent sx={{ pt: tokens.spacing2xs }}>
          <GenerateFormFields_New
            formFieldsAndRules={formFieldsAndRules}
            control={control}
            errors={errors}
            formFieldsWithDefaultValues={{
              type: 'EMAIL',
            }}
          />
        </DialogContent>

        <DialogActions sx={{ px: tokens.spacing2xs, pb: tokens.spacingXs }}>
          <Button onClick={handleClose} color="error">
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isSubmitting}
            onClick={handleSubmit(onFormSubmit)}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
